export const createAgentUiSlice = (set, get) => ({
  isCreating: false,
  fileModalOpen: false,
  filesListModalOpen: false, // New state for files list modal
  modalType: null,
  deleteModalOpen: false,
  agentToDelete: null,
  isTemplatePopoverOpen: false,
  formDefaultValues: null,
  showDeleteModal: false,

  // New states for instruction generation modal
  isInstructionsModalOpen: false,

  // Modal actions
  setIsCreating: (isCreating) => set({ isCreating }),
  openFileModal: (type) => set({ fileModalOpen: true, modalType: type }),
  closeFileModal: () => set({ fileModalOpen: false, modalType: null }),
  
  // New actions for files list modal
  openFilesListModal: () => set({ filesListModalOpen: true }),
  closeFilesListModal: () => set({ filesListModalOpen: false }),

  // Add modal actions
  openInstructionsModal: () => set({ isInstructionsModalOpen: true }),
  closeInstructionsModal: () => set({ isInstructionsModalOpen: false }),

  openDeleteModal: (agentId) =>
    set({ deleteModalOpen: true, agentToDelete: agentId }),
  closeDeleteModal: () => set({ deleteModalOpen: false, agentToDelete: null }),

  // Template popover actions
  setTemplatePopoverOpen: (isOpen) => set({ isTemplatePopoverOpen: isOpen }),

  handleTemplateSelect: async (template) => {
    const { generateSystemInstructions } = get();
    const instructions = await generateSystemInstructions(template);
    
    if (instructions) {
      set((state) => ({
        ...state,
        formDefaultValues: {
          ...state.formDefaultValues,
          systemInstructions: instructions,
        },
      }));
    }
    
    set({ isTemplatePopoverOpen: false });
  },
  // Form actions
  setFormDefaultValues: (values) => set({ formDefaultValues: values }),
  resetFormState: () =>
    set({
      isCreating: false,
      formDefaultValues: null,
      isTemplatePopoverOpen: false,
    }),

  handleEditAgent: (agent) => {
    const { setSelectedAgent, setFormDefaultValues, setIsCreating } = get();
    setSelectedAgent(agent);
    setIsCreating(false);
    setFormDefaultValues({
      name: agent.name,
      systemInstructions: agent.systemInstructions,
      model: agent.model,
      tools: agent.tools,
    });
  },

  handleCreateNew: () => {
    const { setSelectedAgentId, setIsCreating, setFormDefaultValues } = get();
    setSelectedAgentId(null);
    setIsCreating(true);
    setFormDefaultValues({
      id: 0,
      name: "",
      systemInstructions: "",
      fileId: "",
      isFileSearchEnabled: false,
      openAiAssistantId: "",
      projectId: 0,
      openAiProjectId: "",
      authorizerId: "",
      authorizer: "",
    });
  },

  showDeleteConfirmation: (agentId) =>
    set({ showDeleteModal: true, agentToDelete: agentId }),
  hideDeleteConfirmation: () =>
    set({ showDeleteModal: false, agentToDelete: null }),
});
